export default __webpack_public_path__ + "static/media/mathayo.cba05e0e.jpg";